var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_Business_to_Consumer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28 30v-28c0-1.104-.896-2-2-2h-16c-1.104 0-2 .896-2 2v6h-6c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h24c1.104 0 2-.896 2-2zm-20-2h-4v-16h4zm16 0h-4v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-4v-24h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.414 12.586-.586-.586h11.172v14c0 1.104.896 2 2 2s2-.896 2-2v-16c0-1.104-.896-2-2-2h-13.172l.586-.586c.781-.781.781-2.047 0-2.828-.78-.781-2.048-.781-2.828 0l-4 4c-.781.781-.781 2.047 0 2.828l4 4c.39.391.902.586 1.414.586s1.024-.195 1.414-.586c.781-.781.781-2.047 0-2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.414 48.586c-.78-.781-2.048-.781-2.828 0-.781.781-.781 2.047 0 2.828l.586.586h-15.172v-14c0-1.104-.896-2-2-2s-2 .896-2 2v16c0 1.104.896 2 2 2h17.172l-.586.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l4-4c.781-.781.781-2.047 0-2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.26 44.966c1.086-1.365 1.74-3.09 1.74-4.966 0-4.411-3.589-8-8-8s-8 3.589-8 8c0 1.876.654 3.601 1.74 4.966-3.386 1.604-5.74 5.045-5.74 9.034v8c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-8c0-3.989-2.354-7.43-5.74-9.034zm-6.26-8.966c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm8 24h-16v-6c0-3.309 2.691-6 6-6h4c3.309 0 6 2.691 6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2C);
export default __webpack_public_path__ + "static/media/b2c.1798d66b86d4de774a2a6565769bc239.svg";
export { ForwardRef as ReactComponent };